
interface RuleType {
    Bool: { key: string, value: string }
    Contains: { key: string, value: string }
    Equal: { key: string, value: string }
    TitleOrUpperCase: { key: string, value: string }
}

export const RuleType: RuleType = Object.freeze({
    Bool: {
        key: "Bool",
        value: "Boolean"
    },
    Contains: {
        key: "Contains",
        value: "Contains"
    },
    Equal: {
        key: "Equal",
        value: "Equals"
    },
    TitleOrUpperCase: {
        key: "TitleOrUpperCase",
        value: "Title or Upper Case"
    }
});

interface ValueType {
    MatchingOneOf: { key: string, value: string }
    Matching: { key: string, value: string }
}

export const ValueType: ValueType = Object.freeze({
    MatchingOneOf: {
        key: "MatchingOneOf",
        value: "Matching One Of"
    },
    Matching: {
        key: "Matching",
        value: "Matching"
    }
});